import { Link } from "react-router-dom";
import CoverText from "./CoverText";

function InfoCover({ page, text }) {
    return (
        <div className="row slide-show">
            <div className="black-filter"></div>

            <video className="w-100 h-100 welcome-video" src="./Videos/welcome.mp4" preload="false" autoPlay={true} muted={true} playsInline={true} loop={true} />

            <CoverText page={page} text={text} />
        </div>
    );
}

export default InfoCover;